import { useState } from 'react';
import { faqData } from '@/mocks/comics';

function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            关于韩漫之家的常见疑问，这里都有答案
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl overflow-hidden transition-all duration-300"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer whitespace-nowrap"
              >
                <h4 className="font-heading text-sm font-bold text-foreground-950 pr-4">
                  <a id={`faq-${index}`} href={`#faq-${index}`} className="no-underline text-inherit">
                    {faq.question}
                  </a>
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === index
                    ? 'bg-primary-500 text-background-50 rotate-45'
                    : 'bg-background-100 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-5 px-5 md:px-6' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQSection;